import "./ProjectsServices.module.css";
import WebsiteHeader from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CaseShowcaseArea from "./sections/CaseShowcaseArea";
import ServiceImportProcess from "./sections/ServiceImportProcess";
//import Showproject from "./sections/Showproject"
import Footer from "@/reusable_sections/Footer";
export default function ProjectsServicesPage() {
  return <div>
      <WebsiteHeader />
      <Hero />
      <CaseShowcaseArea />
      <ServiceImportProcess />
      {/* <Showproject /> */}
      <Footer />
    </div>;
}